import { Component, OnInit, TemplateRef, ContentChild, Input } from '@angular/core';
import { SectionState } from './section.model';
import { HELP_ANIMATIONS } from './section.animations';

@Component({
    selector: 'jhi-section',
    templateUrl: './section.component.html',
    styleUrls: ['./section.component.scss'],
    animations: [
        ...HELP_ANIMATIONS
    ]
})
export class SectionComponent implements OnInit {

    @ContentChild('header')
    headerRef: TemplateRef<any>;

    @ContentChild('help')
    helpRef: TemplateRef<any>;

    @ContentChild('content')
    contentRef: TemplateRef<any>;

    @Input()
    state: SectionState;

    constructor() {}

    ngOnInit() {
    }

    toggle(): void {
        this.state.isHelpOpen = !this.state.isHelpOpen;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/section/section.component.ts